import { createFileRoute, redirect } from "@tanstack/react-router";
import { TestLoginPage } from "@/features/test/TestLogin";

export const Route = createFileRoute("/test-login")({
  component: TestLoginPage,
  beforeLoad: () => {
    // Redirect to home page in production environment
    if (!import.meta.env.DEV) {
      throw redirect({ to: "/" });
    }
  },
});
